var MemberEmailManager = function(){

    var _init = function(){

        $('#change-primary-email').on('click',function(){
            Do.Ajax('/user/change-primary-email',{})
        });
        MemberEmailManager.watch();
    }
    
    var _watch = function(){
        
        $('#primary-email-check-submit').off().on('click',function(){
            Do.Ajax('/user/validate-primary-email',{
                email2:$('input[name="email2"]').val()
            })
        });

        $('#primary-onetime-check-submit').off().on('click',function(){
            Do.Ajax('/user/verify-primary-email',{
                code:$('input[name="onetime"]').val(),
                token:$('input[name="token"]').val()
            })
        });

        $('#request-secondary-email').off().on('click',function(){
            Do.Ajax('/user/reqsec-email',{ email2:$('input[name="email2"]').val()});
        });
        
        $('#secondary-email-check-submit').off().on('click',function(){
            Do.Ajax('/user/verify-secondary-email',{
                token:$('input[name="token"]').val(),
                code:$('input[name="code"]').val()
            })
        });

        $('#swap-secondary-primary').off().on('click',function(){
            Do.Ajax('/user/swap-prisec-emails',{})
        });

        $('#remove-secondary').off().on('click',function(){
            Do.Ajax('/user/remsec-email',{})
        });
        
        $('#resend-verification-code').off().on('click',function(){
            Do.Ajax('/user/secmail-resend-code',{})
        });

        $('#unsuppress-me').off().on('click',function(){
            Do.Ajax('/user/email/suppression',{});
        });

        $('.list-sub-update').off().on('click',function(){
            Do.Ajax('/user/email/subscribe',{
                list_uuid: $(this).val(),
                checked: $(this).is(':checked') ? 1 : 0,
            });
        });
        
    }

    var _paintPrimaryEmail = function(response){
        switch(response.step){
            
            case 1: 
            case 2: 
            case 3: 
                $('#primary-email-check-modal').find('#primary-email-check-content').html(response.html);
                break;
    
            case 4: 
            $('#primary-email-check-modal').find('#primary-email-check-content').html(response.html);
            if(response.second){
                $('#secondary-email-group').html(response.second);
            }
            break;
    
        }
        MemberEmailManager.watch();
    }

    return {
        init: function(){
            _init();
        },
        watch: function(){
            _watch();
        },
        paintPrimaryEmail: function(r){
            _paintPrimaryEmail(r);
        },
        paintSecondaryModal: function(response){
            $('#secondary-email-check-modal').modal('show').find('#secondary-email-check-content').html(response.html);
            $('#secondary-email-group').html(response.second);
            MemberEmailManager.watch();
        },
        paintPriSecEmails: function(response){
            MemberEmailManager.watch();
            $('#static-primary-email').text(response.primary);
            $('#static-secondary-email').text(response.secondary);
            MemberEmailManager.watch();
            Do.Notify(response);
        },
        paintPriSecEmails: function(response){
            MemberEmailManager.watch();
            $('#static-primary-email').text(response.primary);
            $('#static-secondary-email').text(response.secondary);
            MemberEmailManager.watch();
            Do.Notify(response);
        },
        remSecEmail: function(response){
            $('#static-primary-email').text(response.primary);
            $('#secondary-email-group').html(response.secondary);
            MemberEmailManager.watch();
            Do.Notify(response);
        },
        paintAfterUnsuppress: function(response){
            $('#suppressed-warning').addClass('d-none');
            $('#icon-warn-suppressed').attr('hidden');
            $('.list-sub-update').removeAttr('disabled');
            Do.Notify(response);
        },
    }

}();
